import React from "react";
import { Box, Container, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useNavigate } from "react-router-dom";
import { BorderBottom } from "@mui/icons-material";

const CommonBreadcrumb = ({
    items,
}) => {
    const navigate = useNavigate();

    // 🔥 convert label → path
    const generatePath = (labels, index) => {
        const path = labels
            .slice(0, index + 1)
            .map((item) =>
                item.toLowerCase().replace(/\s+/g, "-")
            )
            .join("/");

        return `/${path}`;
    };

    return (
        <Box
            sx={{
                width: "100%",
                background: "#fff",
                borderBottom: '1px solid #eee'
            }}
        >
            <Container>
                <Box
                    sx={{
                        py: 1.5,
                        px: { xs: 2, md: 0 },
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    {/* LEFT SIDE */}
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {/* HOME (FIXED) */}
                        <Typography
                            onClick={() => navigate("/")}
                            sx={{
                                fontSize: "14px",
                                fontWeight: 500,
                                color: "#8c96a5",
                                cursor: "pointer",
                                "&:hover": { color: "#2b5c9e" },
                            }}
                        >
                            Home
                        </Typography>

                        <ChevronRightIcon
                            sx={{
                                fontSize: 18,
                                color: "#f5c242",
                                mx: 0.5,
                            }}
                        />

                        {/* DYNAMIC ITEMS */}
                        {items.map((item, index) => {
                            const isLast = index === items.length - 1;
                            const path = generatePath(items, index);

                            return (
                                <React.Fragment key={index}>
                                    <Typography
                                        onClick={() => {
                                            if (!isLast) navigate(path);
                                        }}
                                        sx={{
                                            fontSize: "14px",
                                            fontWeight: isLast ? 600 : 500,
                                            color: isLast ? "#2b5c9e" : "#8c96a5",
                                            cursor: isLast ? "default" : "pointer",
                                            "&:hover": {
                                                color: isLast ? "#2b5c9e" : "#2b5c9e",
                                            },
                                        }}
                                    >
                                        {item}
                                    </Typography>

                                    {!isLast && (
                                        <ChevronRightIcon
                                            sx={{
                                                fontSize: 18,
                                                color: "#f5c242",
                                                mx: 0.5,
                                            }}
                                        />
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </Box>

                    {/* RIGHT ICON */}
                    <Box
                        onClick={() => window.open("/", "_blank")}
                        sx={{
                            width: 32,
                            height: 32,
                            borderRadius: "4px",
                            border: "1px solid #cfd8dc",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            background: "#fff",
                            "&:hover": { background: "#eef3f8" },
                        }}
                    >
                        <OpenInNewIcon sx={{ fontSize: 18, color: "#9fb3c8" }} />
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default CommonBreadcrumb;